<div class="container-fluid">
  <app-content-tab-list activeTab="1" type="management" category="Management"></app-content-tab-list>

  <section class="mb-5 mt-0">
    <div class="row mt-4 align-items-center">
      <div class="col-12 col-md-7 col-lg-7 col-xl-7 my-3">
        <div class="home-details">
          <h5 class="home-title">Categories<span><i class="bi bi-box-arrow-right"></i></span></h5>
          <p class="home-subtitle">List of all Categories</p>
        </div>
      </div>
      <div class="col-12 col-md-7 col-lg-5 col-xl-5">
        <div class="dashboard-btn dashboard-manage">
          <!-- <div> <a href="#"><button class="btn btn-primary btn-deshboard">Export list</button></a></div> -->
          <a routerLink="/categories/create-category">
            <button class="btn btn-primary btn-dashboard mt-2"><i class="las la-plus"></i>Create new Category</button>
          </a>
          <div class="filter-row filter-row1">
            <div class="form-label show">Sort by :</div>
            <div class="select-wrapper-sm">
              <select class="form-control border-0 input-sm" [(ngModel)]="sortType"
                (ngModelChange)="getAllCategories(sortType)">
                <option selected disabled value="">Sort-By</option>
                <option value="?sort=ASC">Name (A-Z)</option>
                <option value="?sort=DESC">Name (Z-A)</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <table class="table table-bordered user-table">
      <thead>
        <tr>
          <th scope="col">ID</th>
          <th scope="col">Category Name</th>
          <th scope="col">Icon</th>
          <th scope="col">Status</th>
          <th scope="col">Created At</th>
          <th scope="col">Actions</th>
        </tr>
      </thead>
      @if (!loading && !!categories?.length) {
        <tbody>
          @for (c of categories; track c; let i = $index) {
            <tr class="client">
              <td class="text-nowrap" [attr.title]="(c.id || '').toUpperCase()"><span>{{(c.id || '').slice(-6).toUpperCase()}}</span>
              <i (click)="handleCopyToClipboard(c.id);" class="las la-copy la-lg pointer copy-icon"></i>
            </td>
            <td>{{c.categoryName}}</td>
            <td><img src="{{c.icon}}" alt="" width="40"></td>
            <td [ngClass]="c.status == 'Enabled' ? 'text-success' : 'text-danger'">{{c.status}}</td>
            <td>{{c.createdAt | date: 'medium'}}</td>
            <td class="action">
              <div class="dropdown">
                <button type="button" class="btn header-item waves-effect btn-dropdown" id="page-header-user-dropdown"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                  <a class="   mr-3 text-primary py-2 text-nowrap">
                    View actions <i class="las mb-1 la-angle-down align-middle mr-0"></i></a>
                  </button>
                  <div class="dropdown-menu dropdown-menu-right animate slideIn side-menu-dropdown py-0 rounded-1">
                    <a class=" dropdown-item  text-primary border-bottom py-2 text-nowrap"
                      [routerLink]="['/categories/single-category/', c.id]">
                      <i class="las la-eye mb-1 la-lg  align-middle mr-0"></i> View</a>
                      <a class=" dropdown-item  text-info border-bottom py-2 text-nowrap"
                        [routerLink]="['/categories/edit-category/', c.id]">
                        <i class="las la-edit mb-1 la-lg align-middle mr-0"></i> Edit</a>
                        <a class=" dropdown-item  text-danger border-bottom py-2 text-nowrap"
                          (click)="remove(c.id)">
                          <i class="las la-trash mb-1 la-lg align-middle mr-0"></i> Delete</a>
                        </div>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            }
            @if (loading) {
              <tbody>
                @for (q of loaders; track q; let qi = $index) {
                  <tr class="client">
                    <td>
                      <ngx-skeleton-loader [theme]="{width:'150px', marginBottom: '0px'}"></ngx-skeleton-loader>
                    </td>
                    <td>
                      <ngx-skeleton-loader [theme]="{ width:'200px', marginBottom: '0px'}"></ngx-skeleton-loader>
                    </td>
                    <td>
                      <ngx-skeleton-loader [theme]="{width:'50px', height: '50px', borderRadius: '50%', marginBottom: '0px'}"></ngx-skeleton-loader>
                    </td>
                    <td>
                      <ngx-skeleton-loader [theme]="{width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                    </td>
                    <td>
                      <ngx-skeleton-loader [theme]="{width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                    </td>
                    <td>
                      <ngx-skeleton-loader [theme]="{width:'200px', marginBottom: '0px'}"></ngx-skeleton-loader>
                    </td>
                  </tr>
                }
              </tbody>
            }
          </table>
          @if (!loading && !categories?.length) {
            <div class="d-flex align-items-center justify-content-center py-5">
              No categories found
            </div>
          }
        </section>
      </div>
